var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-policies"},[_c('cms-content',{attrs:{"type":"2","lang":_vm.lang}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }